export default __webpack_public_path__ + "950ffd1efa29c33a70dd86ea761cb3d8.woff";